var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class StoryLinks extends Component {
    constructor() {
        super('StoryLinks', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('body').on('click', '.article .button-up', (event, button) => {
                event.preventDefault();
                $.scrollTo(button.parents('.article').position().y - $('header').height());
            });
            StoryLinks.buttonsSVG['default'] = yield $.httpRequest({
                url: '/wp-content/themes/hanako-wp/views/svg/button-link-goto.twig',
                dataType: 'html',
            });
            StoryLinks.buttonsSVG['video'] = yield $.httpRequest({
                url: '/wp-content/themes/hanako-wp/views/svg/button-link-video.twig',
                dataType: 'html',
            });
            StoryLinks.buttonsSVG['sound'] = yield $.httpRequest({
                url: '/wp-content/themes/hanako-wp/views/svg/button-link-sound.twig',
                dataType: 'html',
            });
            $('article').forEach((article) => {
                StoryLinks.initArticleLinks(article);
            });
            this.success();
        });
    }
    static initArticleLinks(article) {
        $(article).find('.text a[href^="#"]').forEach((link) => {
            const targetModule = $($(link).attr('href'));
            var type = targetModule.data('type');
            if (type != 'sound' && type != 'video')
                type = 'default';
            $(link).append($(StoryLinks.buttonsSVG[type].get(0).cloneNode(true)));
            $(link).on('click', (event) => {
                event.preventDefault();
                var bodyRect = document.body.getBoundingClientRect();
                $.scrollTo(targetModule.get(0).getBoundingClientRect().top - bodyRect.top - $('header').get(0).getBoundingClientRect().height - 18);
            });
        });
    }
}
StoryLinks.buttonsSVG = {};
